
export default {
  // Header
  'header.home': 'Home',
  'header.superone': 'SuperOne',
  'header.contact': 'Kontakt',
  'header.imprint': 'Impressum',
  'header.privacy': 'Datenschutz',
  
  // Footer
  'footer.quickLinks': 'Quick Links',
  'footer.legal': 'Rechtliches',
  'footer.contact': 'Kontakt',
  'footer.rights': 'Alle Rechte vorbehalten.',
  'footer.company': 'Future Now Ltd.',
  'footer.address': 'Victoriastreet 2a, SWE-1, London, United Kingdom',
  'footer.email': 'info@olaf-niggemann.com',
  
  // Cookie Banner
  'cookie.title': 'Cookie-Einstellungen',
  'cookie.description': 'Wir verwenden Cookies, um Ihre Erfahrung auf unserer Website zu verbessern. Durch die Nutzung unserer Website stimmen Sie der Verwendung von Cookies zu.',
  'cookie.accept': 'Alle akzeptieren',
  'cookie.reject': 'Ablehnen',
  'cookie.customize': 'Anpassen',
  'cookie.necessary': 'Notwendig',
  'cookie.analytics': 'Analytik',
  'cookie.marketing': 'Marketing',
  'cookie.necessaryDesc': 'Diese Cookies sind für die Grundfunktionen der Website erforderlich.',
  'cookie.analyticsDesc': 'Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren.',
  'cookie.marketingDesc': 'Diese Cookies werden verwendet, um Werbung relevanter für Sie zu machen.',
  'cookie.save': 'Einstellungen speichern',
  
  // Maintenance
  'maintenance.title': 'Wartungsmodus',
  'maintenance.subtitle': 'Diese Seite befindet sich im Wartungsmodus. Wir sind in Kürze zurück.',
  'maintenance.description': 'Wir arbeiten gerade an Verbesserungen für Sie. Vielen Dank für Ihre Geduld.',
  'maintenance.contact': 'Bei dringenden Anfragen erreichen Sie uns unter:',
  
  // Common
  'common.learnMore': 'Mehr erfahren',
  'common.getStarted': 'Jetzt starten',
  'common.readMore': 'Weiterlesen',
  'common.backToHome': 'Zurück zur Startseite',
  'common.loading': 'Lädt...',
  'common.error': 'Fehler',
  'common.success': 'Erfolg',
};
